import { useState, useCallback } from 'react';
import { Link, Copy } from 'lucide-react';
import { admin, palette, radii, typography } from '../../../styles/tokens';

interface BookingUrlCardProps {
  url: string;
  helperText: string;
}

export default function BookingUrlCard({ url, helperText }: BookingUrlCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [url]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '14px 16px',
        marginBottom: 20,
        background: palette.g50,
        border: `1px solid ${palette.g150}`,
        borderRadius: radii.md,
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: radii.sm,
          background: palette.accentWash,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Link size={16} color={palette.accent} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: typography.size.caption,
            fontWeight: typography.weight.semibold,
            color: admin.header,
            marginBottom: 4,
          }}
        >
          Your CrewBit page
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 4,
          }}
        >
          <span
            style={{
              fontSize: typography.size.caption,
              fontWeight: 500,
              color: palette.accent,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {url.replace('https://', '')}
          </span>
          <button
            type="button"
            onClick={handleCopy}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '3px 10px',
              background: palette.white,
              border: `1px solid ${palette.g200}`,
              borderRadius: radii.sm,
              fontSize: typography.size.caption,
              fontWeight: typography.weight.semibold,
              color: palette.accent,
              cursor: 'pointer',
              fontFamily: 'inherit',
              flexShrink: 0,
            }}
          >
            <Copy size={12} />
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <div
          style={{
            fontSize: 12,
            color: admin.caption,
            lineHeight: typography.lineHeight.normal,
          }}
        >
          {helperText}
        </div>
      </div>
    </div>
  );
}
